import edTechImage from "../Assest/ed-tech.png";
import weatherImage from "../Assest/weather-app.png";
import passwordGeneratorImage from "../Assest/password-generator.png";
export const projects = [
    {
      title: "ED-Tech-App",
      description:
        "An educational app built using React, Tailwind, Node.js and MongoDB.",
      image: edTechImage,
      year: "2026",
      role: "Full Stack Developer",
      live: "https://ed-tech-frontend-tau.vercel.app/",
      github: "https://github.com/Ayushi1706/ED-Tech" 
    },
    {
        title: "Weather-App",
        description:
        "A weather app built using React, Tailwind, Node.js and MongoDB.",
        image: weatherImage,
        year: "2025",
        role: "Full Stack Developer",
        live: "https://weather-app-pink-phi.vercel.app/",
        github: "https://github.com/Ayushi1706/Weather-App"
    },
    {
        title: "Password-Generator",
        description:
        "A password generator built using React, Tailwind, Node.js and MongoDB.",
        image: passwordGeneratorImage,
        year: "2025",
        role: "Full Stack Developer",
        live: "https://password-genertor-three.vercel.app/",
        github: "https://github.com/Ayushi1706/Password-Genertor"
    }
  ];